<template>
    <modal height="auto" width="90%" :scrollable="true" @opened="onOpen" @closed="onHidden" name="client-log" classes="modal_default" :clickToClose="true">
    <div class="card" data-testid="client-log-modal">
        <div class="card-header">
            Historie úprav klienta
        </div>
        <div class="card-body" v-if="logClient.length > 0 && logClientPending !== true">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">verze</th>
                        <th scope="col">akce</th>
                        <th scope="col">změna</th>
                        <th scope="col">provedl</th>
                        <th scope="col">datum a čas</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="log in logClient" data-testid="client-log-row">
                        <td>{{ log.version }}</td>
                        <td>{{ log.action }}</td>
                        <td>
                            <template v-for="(value, key) in log.data">
                                <span><i>{{ key }}</i>: <b>{{ value }}</b></span><br>
                            </template>
                        </td>
                        <td>{{ log.username }}</td>
                        <td>{{ log.logged_at }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body" data-testid="client-log-empty" v-if="logClient.length < 1 && logClientPending !== true">
            klient bez historie
        </div>
    </div>
    </modal>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        modalOpened: false,
        logClient: false,
        logClientPending: true,
        logClientError: false
      }
    },
    props: ['opened', 'clientId'],
    mixins: [apiMixin],
    methods: {
      onHidden () {
        // this.opened = false
      },
      onOpen () {
        this.init()
        this.getLogClient(this.clientId)
      },
      getLogClient (clientId) {
        this.logClientPending = true
        this.$http.get('log_client/' + clientId).then(response => {
          this.logClient = response.data
          this.logClientPending = false
        }, response => {
          this.logClientError = response.body.error
          this.logClientPending = false
        })
      },
      init () {
        this.logClient = false
        this.logClientPending = false
        this.logClientError = false
      }
    },
    watch: {
      opened (val) {
        if (val === true) {
          // console.log('otevreno')
        }
      },
      visitDone (val) {
        if (val === true) {
          this.$emit('close')
          // this.visitDone = false
          // this.initialSet()
          // this.visit.client_id = this.$route.params.clientid
          this.$modal.hide('client-visit-now-add')
        }
      },
      '$route' (to, from) {
        if (to.params.clientid !== from.params.clientid && typeof (to.params.clientid) !== 'undefined') {
          // this.init()
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>


// WEBPACK FOOTER //
// src/views/Client/modals/ClientLog.vue?d1dabd3e